import { useTranslation } from "hooks/useTranslation";
import styles from "./SampleProcessing.module.css";
import { IconDarkClose } from "icons";
import { Button } from "shared/components/Button";
import SampleProcessingPhoto from "./sample_processing.jpg";

export const SampleProcessing = ({ hasCloseIcon, handleClose }) => {
  const { translate } = useTranslation();
  return (
    <div className={styles.container}>
      {!!hasCloseIcon && (
        <div onClick={handleClose} className={styles.closeIconContainer}>
          <IconDarkClose />
        </div>
      )}
      <h4 className={styles.title}>Pillarhouse Sample Processing Capabilities and Procedures</h4>
      <div className={styles.descriptionContent}>
        <div className={styles.imageContainer}>
          <img src={SampleProcessingPhoto} alt="Sample Processing" className={styles.image} />
        </div>
        <p className={styles.description}>
          Pillarhouse offers comprehensive in-house sample processing capabilities at our Elk Grove Village, IL demonstration center. Our team provides a full spectrum of support—from preliminary cycle-time estimation using customer Gerber files in our offline estimation tool, to full on-machine testing using actual customer-supplied samples.
        </p>
        <p className={styles.description}>
          We conduct real-world trials using customer-specified fluxes, alloys, and process requirements to ensure accurate and relevant results. As part of our standard process, Pillarhouse supplies detailed photographs, retains copies of sample programs for potential use after purchase, and issues a complete report outlining process details, performance insights, and processing speeds.
        </p>
        <p className={styles.description}>
          With a wide range of selective soldering technologies across all customer sectors, Pillarhouse prides itself on delivering the most accurate technical data and trusted guidance to help customers select the highest-value machine for their application.
        </p>
        <p className={styles.header}>
          <h3>PROCESSING STEPS</h3>
        </p>
        <p className={styles.description}>
          All submitted samples must include the Pillarhouse Sample Processing Form, downloadable from the Technical Downloads section of the PillarSALES website. All samples must be addressed to the “Pillarhouse Samples Department” and not to any individual.
        </p>
        <p className={styles.description}>
          We strongly advise that a completed copy of the form be emailed in advance to the sales representative managing the project and that a printed copy be included inside the sample shipment. Please be aware that we receive a high volume of sample requests and missing or incomplete documentation may delay processing or reduce the efficiency of our response.
        </p>
      </div>
      <Button onClick={handleClose} size="m">
        {translate("Ok")}
      </Button>
    </div>
  );
};